class FsMultibuy extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.cart = document.querySelector('cart-drawer');

    this.atcButtons.forEach(button => {
      button.addEventListener("click", this.handleAddToCart.bind(this), { signal });
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get atcButtons() {
    return document.querySelectorAll("[data-single-atc-btn]");
  }

  async handleAddToCart(e) {
    e.preventDefault();

    const variantId = e.currentTarget?.dataset.variantId;
    if(!variantId) return;

    const formData = {
      items: [{
        id: variantId,
        quantity: 5
      }]
    };

    try {
      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
      }

      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();
      
      this.cart?.renderContents(data);

      document.querySelector('cart-drawer').classList.remove("is-empty");

    } catch (error) {
      console.error('Error:', error);
    }
  }
}

if(!customElements.get("fs-multibuy")) {
  customElements.define("fs-multibuy", FsMultibuy);
}
